import { getWindow } from "./utils";

export const injectFont = () => {
    const fontRegular = require("./fonts/rubik/rubik-v21-latin-regular.woff2");
    const font500 = require("./fonts/rubik/rubik-v21-latin-500.woff2");
    const font700 = require("./fonts/rubik/rubik-v21-latin-700.woff2");

    const fullAppPath = getWindow().__APP_ORIGIN__ ?? "";

    const css = `
        @font-face {
            font-family: "Rubik";
            font-display: swap;
            font-weight: 400;
            src: url(${fullAppPath}${fontRegular}) format("woff2");
        }
        @font-face {
            font-family: "Rubik";
            font-display: swap;
            font-weight: 500;
            src: url(${fullAppPath}${font500}) format("woff2");
        }
        @font-face {
            font-family: "Rubik";
            font-display: swap;
            font-weight: 700;
            src: url(${fullAppPath}${font700}) format("woff2");
        }
    `;

    const head = document.head || document.getElementsByTagName("head")[0];
    const style = document.createElement("style");
    head.appendChild(style);
    style.appendChild(document.createTextNode(css));
};
